export const AI_CHAT_BOTTOM_SHEET = 'ai-chat-bottom-sheet';
export const MESSAGE_USER = 'user';
export const MESSAGE_ASSISTANT = 'assistant';
export const MIN_TEXTAREA_ROWS = 1;
export const MAX_TEXTAREA_ROWS = 5;
export const AI_CHAT_ONBOARDING_STORAGE_KEY =
  'free-avia:ai-chat-onboarding-shown';
export const AI_CHAT_SESSION_STORAGE_KEY = 'free-avia:ai-chat-session-id';
